import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5609a67c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer_input" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_4 = { class: "ticket-info" }
const _hoisted_5 = { class: "icon-and-text" }
const _hoisted_6 = { class: "icon-and-text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "selections" }, null, -1))
const _hoisted_8 = { class: "input-fields" }
const _hoisted_9 = { class: "input-fields-wrapper" }
const _hoisted_10 = { class: "input-fields-wrapper" }

import { reactive, PropType } from "vue";
import CustomInputField from "../generics/CustomInputField.vue";
import CustomSelect from "../generics/CustomSelect.vue";
import PersonIcon from "../../assets/SVG/personIcon.vue";
import SeatIcon from "../../assets/SVG/seatIcon.vue";
import { useBookingStore } from "@/store/bookingStore";
import ticket from "@/types/ticket";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerInputBlock',
  props: {
	index_in_shoppingcart: {
		type: Number,
		required: true,
	},
	shopping_cart_ticket: {
		type: Object as PropType<ticket>,
		required: true,
	},
},
  setup(__props) {

const props = __props;



const bookingStore = useBookingStore();

const state = reactive({
	firstName: props.shopping_cart_ticket.firstName,
	lastName: props.shopping_cart_ticket.lastName,
	country: props.shopping_cart_ticket.country,
	birthday: props.shopping_cart_ticket.dateOfBirth,
});

function handleFirstNameInput(input: string) {
	state.firstName = input;
	bookingStore.update_ticket_in_shoppingcard(props.index_in_shoppingcart, {
		firstName: state.firstName,
	});
}

function handleLastNameInput(input: any) {
	state.lastName = input;
	bookingStore.update_ticket_in_shoppingcard(props.index_in_shoppingcart, {
		lastName: state.lastName,
	});
}

function handleBirthdayInput(input: any) {
	state.birthday = input;
	bookingStore.update_ticket_in_shoppingcard(props.index_in_shoppingcart, {
		dateOfBirth: state.birthday,
	});
}

function handleCountryInput(input: any) {
	state.country = input;
	bookingStore.update_ticket_in_shoppingcard(props.index_in_shoppingcart, {
		country: input.value,
	});
}

function handleAgeSelected(input: any) {
	bookingStore.update_ticket_in_shoppingcard(props.index_in_shoppingcart, {
		age: input.value,
	});
}

function handleComfortSelected(input: any) {
	bookingStore.update_ticket_in_shoppingcard(props.index_in_shoppingcart, {
		comfort: input.value,
	});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(bookingStore).get_ticket_by_id(__props.shopping_cart_ticket.id).title), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(PersonIcon),
        _createVNode(CustomSelect, {
          id: String(__props.index_in_shoppingcart),
          label: "Åldersgrupp",
          options: [
						{ value: 'CHD', name: 'Barn' },
						{ value: 'YTH', name: 'Ungdom' },
						{ value: 'ADT', name: 'Vuxen' },
						{ value: 'SEN', name: 'Senior' },
					],
          destyle: true,
          initialySelected: 
						[
							{ value: 'CHD', name: 'Barn' },
							{ value: 'YTH', name: 'Ungdom' },
							{ value: 'ADT', name: 'Vuxen' },
							{ value: 'SEN', name: 'Senior' },
						].find((select_obj) => select_obj.value == __props.shopping_cart_ticket.age)
							?.name
					,
          onSelected: handleAgeSelected
        }, null, 8, ["id", "initialySelected"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(SeatIcon),
        _createVNode(CustomSelect, {
          id: String(__props.index_in_shoppingcart),
          label: "Klass",
          options: [
						{ value: 'first', name: 'Första klass' },
						{ value: 'second', name: 'Andra klass' },
					],
          destyle: true,
          initialySelected: 
						[
							{ value: 'first', name: 'Första klass' },
							{ value: 'second', name: 'Andra klass' },
						].find(
							(select_obj) => select_obj.value == __props.shopping_cart_ticket.comfort
						)?.name
					,
          onSelected: handleComfortSelected
        }, null, 8, ["id", "initialySelected"])
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(CustomInputField, {
          id: String(__props.index_in_shoppingcart),
          class: "input-field",
          label: "Förnamn",
          "init-value": __props.shopping_cart_ticket.firstName,
          onOnInput: handleFirstNameInput,
          autocomplete: "given-name"
        }, null, 8, ["id", "init-value"]),
        _createVNode(CustomInputField, {
          id: String(__props.index_in_shoppingcart),
          class: "input-field",
          label: "Efternamn",
          "init-value": __props.shopping_cart_ticket.lastName,
          onOnInput: handleLastNameInput,
          autocomplete: "family-name"
        }, null, 8, ["id", "init-value"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(CustomSelect, {
          id: String(__props.index_in_shoppingcart),
          class: "input-field",
          label: "Födelseland",
          "initialy-selected": __props.shopping_cart_ticket.country,
          autocomplete: "country",
          options: [
						{ value: 'SE', name: 'Sverige' },
						{ value: 'NO', name: 'Norge' },
						{ value: 'DK', name: 'Danmark' },
					],
          onSelected: handleCountryInput
        }, null, 8, ["id", "initialy-selected"]),
        _createVNode(CustomInputField, {
          id: String(__props.index_in_shoppingcart),
          class: "input-field",
          label: "Födelsedatum",
          "init-value": __props.shopping_cart_ticket.dateOfBirth,
          onOnInput: handleBirthdayInput,
          "input-type": "date",
          autocomplete: "bday"
        }, null, 8, ["id", "init-value"])
      ])
    ])
  ]))
}
}

})